import { render, staticRenderFns } from "./studentTip.vue?vue&type=template&id=90843c8a&scoped=true"
import script from "./studentTip.vue?vue&type=script&lang=js"
export * from "./studentTip.vue?vue&type=script&lang=js"
import style0 from "./studentTip.vue?vue&type=style&index=0&id=90843c8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.21_prettier@2.8.8_vue-temp_pgqv4bjfw4n43uthtcnbh5tcie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90843c8a",
  null
  
)

export default component.exports